export default {
    props: {
        disableRipple: true
    },
    styleOverrides: {
        root: {
            boxShadow: 'none',
            padding: '0 16px',
            minHeight: '44px',
            textTransform: 'inherit',
            borderRadius: '4px',
            position: 'relative',
            overflow: 'hidden',
            transform: 'translate3d(0, 0, 0) scale(1, 1)',
            transition: 'transform 50ms ease',
            textRendering: 'optimizeLegibility',
            WebkitFontSmoothing: 'antialiased',
            fontSize: '16px',
            '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                background: 'rgba(255, 255, 255, 0.1)',
                transform: 'translateX(-100%)',
                transition: 'transform 0.3s ease-out',
            },
            '&:hover': {
                boxShadow: 'none',
                '&::before': {
                    transform: 'translateX(0)',
                }
            },
            // Active state
            '&:active': {
                boxShadow: 'none',
                transform: 'translate3d(0, 0, 0) scale(0.99, 0.99)',
            },
            // Disabled state
            '&.Mui-disabled': {
                boxShadow: 'none',
            }
        },
        // You can add specific variants if needed
        contained: {
        // Styles for contained variant
        },
        outlined: {
        // Styles for outlined variant
        }
    }
};
